import { render, staticRenderFns } from "./EditAreaDialog.vue?vue&type=template&id=3593cabb&scoped=true&"
import script from "./EditAreaDialog.vue?vue&type=script&lang=js&"
export * from "./EditAreaDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditAreaDialog.vue?vue&type=style&index=0&id=3593cabb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3593cabb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3593cabb')) {
      api.createRecord('3593cabb', component.options)
    } else {
      api.reload('3593cabb', component.options)
    }
    module.hot.accept("./EditAreaDialog.vue?vue&type=template&id=3593cabb&scoped=true&", function () {
      api.rerender('3593cabb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaigns/EditAreaDialog.vue"
export default component.exports